import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DownOutlined, FilterOutlined } from "@ant-design/icons";
import { Divider, Dropdown, Modal, Row, Space, Button, Flex, Card, Breadcrumb } from "antd";
import { CardContainer } from "components/elements";
import { Input } from "components/form";
import { MainLayout } from "components/layouts";
import PolicyTable from "components/table/PolicyTable";

import {
  policyCategoryInitialValues,
  policyCategorySchema,
} from "../schemas/policySchema";
import styles from "../styles/PolicyList.module.css";
import NewAndPolicyFilters from "./NewAndPolicyFilter";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg"

const PolicyList = ({
  isLoading = false,
  initialValues = {},
  isModalOpen = false,
  policyCategory = [],
  modifiedPolicyCategory = [],
  onCreate = () => { },
  category = "",
  onEdit = () => { },
  onSubmit = () => { },
  onSearch = () => { },
  onStatus = () => { },
  onCancel = () => { },
  onDeletePolicy = () => { },
  onPolicyStatus = () => { },
  onCreatePolicyCategory = () => { },
  onEditPolicyCategory = () => { },
}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);

  return (
    <MainLayout>
      <Modal
        title={
          initialValues.policyCategoryId ? t("common.edit") : t("common.create")
        }
        open={isModalOpen}
        onOk={() => { }}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "policy-category__cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        width="511px"
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...policyCategoryInitialValues, ...initialValues }}
          onSubmit={onSubmit}
          validationSchema={policyCategorySchema}
        >
          {({ resetForm }) => {
            return (
              <Form>
                <Space direction="vertical" size={24} style={{ width: "100%" }}>
                  <Input
                    name="policyCategoryName"
                    placeholder={
                      t("policy.label.category")
                    }
                    size="large"
                    label={
                      t("policy.label.category")
                    }
                    required
                  />
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="policy-category__cancelBtn"
                        type="default"
                        onClick={() => {
                          resetForm();
                          onCancel();
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button htmlType="submit" type="primary" style={{ backgroundColor: "var(--button-color)", height: "40px", borderRadius: "8px" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </Modal>
      <Space className={styles.container} direction="vertical" size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("news_policy.header"), href: "" },
            { title: t("policy_list.header") },
          ]}
          />
          <h2>{t("policy_list.header")}</h2>
        </Flex>
        <Row justify="space-between">
          <div />
          <Space direction="horizontal" size={12}>
            <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ height: "40px", borderRadius: "8px", boxShadow: "none" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "2",
                    label: (
                      <p
                        onClick={onCreatePolicyCategory}
                        style={{ color: "grey", fontSize: "14px" }}
                      >
                        {t("policy.label.policy_category")}
                      </p>
                    ),
                  },
                  {
                    key: "1",
                    label: (
                      <p
                        onClick={(e) => {
                          onCreate();
                        }}
                        style={{ color: "grey", fontSize: "14px" }}
                      >
                        {t("policy.label.company_policy")}
                      </p>
                    ),
                  },
                ],
              }}
            >
              {roles.includes("CREATE_NEWS_&_POLICY|POLICY") ? (
                <Button type="primary" style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", height: "40px", borderRadius: "8px", boxShadow: "none" }}>
                  {t("common.create")} <DownOutlined />
                </Button>
              ) : (
                <></> // Ensure a single child by rendering an empty fragment if condition is false
              )}
            </Dropdown>
          </Space>
        </Row>
        {useFilter && (
          <Card style={{ width: "100%", height: "fit-content", border: "1px solid #EAECF0" }}>
            <NewAndPolicyFilters
              isLoading={isLoading}
              modifiedPolicyCategory={modifiedPolicyCategory}
              onEdit={onEdit}
              dataFlag={"policy"}
              onCancel={onCancel}
              onSearch={onSearch}
            />
          </Card>)}
        <PolicyTable
          isLoading={isLoading}
          dataSource={policyCategory}
          onEdit={onEdit}
          dataFlag={"policy"}
          onStatus={onStatus}
          onPolicyStatus={onPolicyStatus}
          onEditPolicyCategory={onEditPolicyCategory}
          onDeletePolicy={onDeletePolicy}
        />
      </Space>
    </MainLayout>
  );
};

export default PolicyList;
